export default{
    async getNetworkList({}, param){
        return await this.$axios.$post(
            this.$api.tenantAdmin.settings.banNetworks.list,
            param
        )
        .catch(error => {
        })
    },

    async createNetwork({}, network){
        let result = null;
        await this.$axios.$post(
            this.$api.tenantAdmin.settings.banNetworks.create,
            network
        )
        .then(response => {
            this.$alert.success(`「${network.network}」を追加しました`);
            result = 200;
        })
        .catch(error => {
        })
        return result;
    },

    async editNetwork({}, network){
        let result = null;
        await this.$axios.$post(
            this.$api.tenantAdmin.settings.banNetworks.edit,
            network
        )
        .then(response => {
            this.$alert.success(`「${network.network}」を更新しました`);
            result = 200;
        })
        .catch(error => {
        })
        return result;
    },

    async deleteNetwork({}, network){
        let result = null;
        await this.$axios.$post(
            this.$api.tenantAdmin.settings.banNetworks.delete,
            {
                id: network.id
            }
        )
        .then(response => {
            this.$alert.success(`「${network.network}」を削除しました`);
            result = 200;
        })
        .catch(error => {
        })
        return result;
    },
}